import React from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
} from "@material-ui/core";

import firebase from "../../../firebase";
import "firebase/firestore";

import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";

import DateFnsUtils from "@date-io/date-fns";

import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import Radio from "@material-ui/core/Radio";

const db = firebase.firestore();

const useStyles = makeStyles({
  root: {
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  icon: {
    borderRadius: "50%",
    width: 16,
    height: 16,
    boxShadow:
      "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
    backgroundColor: "#f5f8fa",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
    "$root.Mui-focusVisible &": {
      outline: "2px auto rgba(19,124,189,.6)",
      outlineOffset: 2,
    },
    "input:hover ~ &": {
      backgroundColor: "#ebf1f5",
    },
    "input:disabled ~ &": {
      boxShadow: "none",
      background: "rgba(206,217,224,.5)",
    },
  },
  checkedIcon: {
    backgroundColor: "#137cbd",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
    "&:before": {
      display: "block",
      width: 16,
      height: 16,
      backgroundImage: "radial-gradient(#fff,#fff 28%,transparent 32%)",
      content: '""',
    },
    "input:hover ~ &": {
      backgroundColor: "#106ba3",
    },
  },
});

function StyledRadio(props) {
  const classes = useStyles();

  return (
    <Radio
      className={classes.root}
      disableRipple
      color="default"
      checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
      icon={<span className={classes.icon} />}
      {...props}
    />
  );
}

export default function FormDialog(props) {
  const [open, setOpen] = React.useState(false);
  const [nacimiento, setNacimiento] = React.useState(props.registro.nacimiento);
  const [rpcria, setRpcria] = React.useState(props.registro.rpcria);
  const [rpmadre, setRpmadre] = React.useState(props.registro.rpmadre);
  const [padre, setPadre] = React.useState(props.registro.padre);
  const [tregistro, setTtregistro] = React.useState(props.registro.tregistro);
  const [peso, setPeso] = React.useState(props.registro.peso);
  const [observaciones, setObservaciones] = React.useState(
    props.registro.observaciones
  );
  const [sexo, setSexo] = React.useState(props.registro.sexo);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = () => {
    db.collection("registros")
      .doc(props.registro.id)
      .update({
        rpcria,
        nacimiento,
        rpcria,
        rpmadre,
        padre,
        tregistro,
        observaciones,
        sexo,
        peso: Number(peso),
      });
    setOpen(false);
  };

  return (
    <div>
      <div onClick={handleClickOpen}>{props.children}</div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Editar registro</DialogTitle>
        <DialogContent>
          <KeyboardDatePicker
            margin="normal"
            id="date-picker-dialog"
            label="Fecha Nacimiento"
            format="dd/MM/yyyy"
            value={nacimiento}
            maxDate={new Date()}
            onChange={(date) => setNacimiento(date)}
            KeyboardButtonProps={{
              "aria-label": "change date",
            }}
          />
          <TextField
            autoFocus
            margin="dense"
            id="nombre"
            label="Rp Cria"
            type="text"
            fullWidth
            value={rpcria}
            onChange={(e) => setRpcria(e.target.value)}
          />

          <TextField
            autoFocus
            margin="dense"
            id="nombre"
            label="Peso"
            type="number"
            fullWidth
            value={peso}
            onChange={(e) => setPeso(e.target.value)}
          />

          <TextField
            autoFocus
            margin="dense"
            id="nombre"
            label="Rp Madre"
            type="text"
            fullWidth
            value={rpmadre}
            onChange={(e) => setRpmadre(e.target.value)}
          />
          <TextField
            autoFocus
            margin="dense"
            id="nombre"
            label="Padre"
            type="text"
            fullWidth
            value={padre}
            onChange={(e) => setPadre(e.target.value)}
          />
          <TextField
            autoFocus
            margin="dense"
            id="nombre"
            label="Tipo Registro"
            type="text"
            fullWidth
            value={tregistro}
            onChange={(e) => setTtregistro(e.target.value)}
          />
          <TextField
            autoFocus
            margin="dense"
            id="nombre"
            label="Observaciones"
            type="text"
            fullWidth
            value={observaciones}
            onChange={(e) => setObservaciones(e.target.value)}
          />

          <FormControl component="fieldset">
            <FormLabel component="legend">Sexo</FormLabel>
            <RadioGroup
              value={sexo}
              aria-label="gender"
              name="customized-radios"
              onChange={(e) => setSexo(e.target.value)}
            >
              <FormControlLabel
                value="macho"
                control={<StyledRadio />}
                label="Macho"
              />
              <FormControlLabel
                value="hembra"
                control={<StyledRadio />}
                label="Hembra"
              />
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleSave} color="primary">
            Guardar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
